<div class="row main-content">
    <div class="w15">
        <div class="sidebar">
            <ul>
                <li *ngIf="checkOVRInAgencyCode==='false'"routerLink="/dashboard/sales-home"><img src="./assets/images/home.svg"><a>Home</a></li>
                <li *ngIf="checkOVRInAgencyCode==='false'" (click)="goToQuotePurchase()" [ngClass]="{'op5': hideQuotePurchase==='true' || agentIdActive=='false' || !isDisabled}"><img src="./assets/images/quotePurchase.svg"><a>QUOTE / PURCHASE</a></li>
                <li *ngIf="checkOVRInAgencyCode==='false'"  routerLink="/dashboard/policy-search"><img src="./assets/images/policySearch.svg"><a>POLICY SEARCH</a></li>
                <li *ngIf="checkOVRInAgencyCode==='false'" (click)="goToSaveQuote()" [ngClass]="{'op5': agentIdActive==='false'}"><img src="./assets/images/home.svg"><a>SAVED QUOTES</a></li>
                <!-- <li routerLink="/dashboard/Groups"><img src="./assets/images/home.svg"><a>GROUPS</a></li> -->
                <li (click)="goToforms()" [ngClass]="{'op5': agentIdActive==='false'}"><img src="./assets/images/file-text.svg"><a>POLICY DOCUMENTS</a></li>
                <!-- <li routerLink="/dashboard/agency-admin"><img src="./assets/images/archive.svg"><a>AGENCY ADMIN</a></li> -->
                <li class="active" routerLink="/dashboard/sales-report"><img src="./assets/images/pie-chart.svg"><a>REPORTS</a></li>
                <li (click)="goToResources()" [ngClass]="{'op5': agentIdActive==='false'}"><img src="./assets/images/resources.svg"><a>RESOURCES</a></li>
            </ul>
        </div>
    </div>
    <div class="w85">
        <div class="row report-details-header p-3">
            <div class="bold fs-20 txt-black1 curPtr" (click)="goToReportTab()">Reports ></div>
            <div class="bold fs-20 txt-red">&nbsp;{{reportType}}</div>
        </div>
        <div class="row px-3 pt-3">
            <label class="bold fs-20 txt-black1">Report Details</label>
            
        </div>
        <!-- <div  *ngIf="reportType == 'Broker Sales'" class="row px-3 pb-1">
            <label class="regular fs-16 txt-black1">
                Please note: The report will be based on data as of yesterday. sales from today will not be included.
            </label>
        </div> -->
        <div *ngIf="reportType == 'Broker Commission Statement' || reportType == 'Broker Sales Report' || reportType == 'MGA OVR Commission Statement' || reportType == 'MGA Sales by Broker' || reportType == 'MGA Commission'">
            <div class="row p-3">
                <div class="col-sm-3 col-md-3 col-lg-3 col-xl-3 col-3">
                    <label class="regular fs-16 txt-clr-grey">Statement Date</label>
                    <ng-select placeholder="Select" [(ngModel)]="statement_date">
                        <ng-option *ngFor="let item of StatementDate" [value]="item.statmentDate">{{item.statmentDate}}</ng-option>
                    </ng-select>
                </div>
            </div>
            <div class="row p-3">
                <div class="col-sm-3 col-md-3 col-lg-3 col-xl-3 col-3">
                    <label class="regular fs-16 txt-clr-grey">Report Format</label>
                    <ng-select placeholder="Select" [(ngModel)]="report_format">
                        <ng-option *ngFor="let item of ReportFormat" [value]="item.type">{{item.name}}</ng-option>
                    </ng-select>
                </div>
            </div>
            <div class="row p-3">
                <div class="col-sm-3 col-md-3 col-lg-3 col-xl-3 col-3 button-alignment">
                    <button type="button" class="fs-16 regular download-button" (click)="download()">Download Report</button>
                </div>
            </div>
        </div>
        <!-- <div *ngIf="reportType == 'Broker Sales'">
            <div class="row p-3">
                <div class="col-sm-3 col-md-3 col-lg-3 col-xl-3 col-3">
                  <label class="regular fs-16 txt-clr-grey">Application Date From</label>
                  <input class="form-control forminput Tab" placeholder="MM-DD-YYYY" [owlDateTimeTrigger]="dt1" [owlDateTime]="dt1" [max]="maxDate" [(ngModel)]="application_date_from">
                  <owl-date-time [pickerType]="'calendar'" #dt1></owl-date-time>
                </div>
            </div>
            <div class="row p-3">
                <div class="col-sm-3 col-md-3 col-lg-3 col-xl-3 col-3">
                  <label class="regular fs-16 txt-clr-grey">Application Date To</label>
                  <input class="form-control forminput Tab" placeholder="MM-DD-YYYY" [owlDateTimeTrigger]="dt2" [owlDateTime]="dt2" [max]="maxDate" [(ngModel)]="application_date_to">
                  <owl-date-time [pickerType]="'calendar'" #dt2></owl-date-time>
                </div>
            </div>
            <div class="row p-3">
                <div class="col-sm-3 col-md-3 col-lg-3 col-xl-3 col-3">
                  <label class="regular fs-16 txt-clr-grey">Report Format</label>
                  <ng-select placeholder="Select" [(ngModel)]="report_format">
                      <ng-option *ngFor="let item of ReportFormat" [value]="item.type">{{item.name}}</ng-option>
                  </ng-select>
                </div>
            </div>
            <div class="row p-3">
                <div class="col-sm-3 col-md-3 col-lg-3 col-xl-3 col-3 button-alignment">
                    <button type="button" class="fs-16 regular download-button" (click)="download()">Download Report</button>
                </div>
            </div>
        </div> -->
        <!-- <div *ngIf="reportType == 'MGA OVR - Commission to Broker'">
            <div class="row p-3">
                <div class="col-sm-3 col-md-3 col-lg-3 col-xl-3 col-3">
                    <label class="regular fs-16 txt-clr-grey">Application Date From</label>
                    <input class="form-control forminput Tab" placeholder="MM-DD-YYYY" [owlDateTimeTrigger]="dt3" [owlDateTime]="dt3" [max]="maxDate" [(ngModel)]="application_date_from">
                  <owl-date-time [pickerType]="'calendar'" #dt3></owl-date-time>
                </div>
            </div>
            <div class="row p-3">
                <div class="col-sm-3 col-md-3 col-lg-3 col-xl-3 col-3">
                    <label class="regular fs-16 txt-clr-grey">Application Date To</label>
                    <input class="form-control forminput Tab" placeholder="MM-DD-YYYY" [owlDateTimeTrigger]="dt4" [owlDateTime]="dt4" [max]="maxDate" [(ngModel)]="application_date_to">
                  <owl-date-time [pickerType]="'calendar'" #dt4></owl-date-time>
                </div>
            </div>
            <div class="row p-3">
                <div class="col-sm-3 col-md-3 col-lg-3 col-xl-3 col-3">
                  <label class="regular fs-16 txt-clr-grey">Report Format</label>
                  <ng-select placeholder="Select" [(ngModel)]="report_format">
                      <ng-option *ngFor="let item of ReportFormat" [value]="item.type">{{item.name}}</ng-option>
                  </ng-select>
                </div>
            </div>
            <div class="row p-3">
                <div class="col-sm-3 col-md-3 col-lg-3 col-xl-3 col-3 button-alignment">
                    <button type="button" class="fs-16 regular download-button" (click)="download()">Download Report</button>
                </div>
            </div>
        </div>
        <div *ngIf="reportType == 'MGA Sales by Broker'">
            <div class="row p-3">
                <div class="col-sm-3 col-md-3 col-lg-3 col-xl-3 col-3">
                    <label class="regular fs-16 txt-clr-grey">Application Date From</label>
                    <input class="form-control forminput Tab" placeholder="MM-DD-YYYY" [owlDateTimeTrigger]="dt5" [owlDateTime]="dt5" [max]="maxDate" [(ngModel)]="application_date_from">
                  <owl-date-time [pickerType]="'calendar'" #dt5></owl-date-time>
                </div>
            </div>
            <div class="row p-3">
                <div class="col-sm-3 col-md-3 col-lg-3 col-xl-3 col-3">
                    <label class="regular fs-16 txt-clr-grey">Application Date To</label>
                    <input class="form-control forminput Tab" placeholder="MM-DD-YYYY" [owlDateTimeTrigger]="dt6" [owlDateTime]="dt6" [max]="maxDate" [(ngModel)]="application_date_to">
                  <owl-date-time [pickerType]="'calendar'" #dt6></owl-date-time>
                </div>
            </div>
            <div class="row p-3">
                <div class="col-sm-3 col-md-3 col-lg-3 col-xl-3 col-3">
                    <label class="regular fs-16 txt-clr-grey">Report Format</label>
                    <ng-select placeholder="Select" [(ngModel)]="report_format">
                      <ng-option *ngFor="let item of ReportFormat" [value]="item.type">{{item.name}}</ng-option>
                  </ng-select>
                </div>
            </div>
            <div class="row p-3">
                <div class="col-sm-3 col-md-3 col-lg-3 col-xl-3 col-3 button-alignment">
                    <button type="button" class="fs-16 regular download-button" (click)="download()">Download Report</button>
                </div>
            </div>
        </div> -->
    </div>
</div>
